module.exports = __webpack_public_path__ + "img/tuohi.9ad5196.png";